import { render, staticRenderFns } from "./upload-contract-page.vue?vue&type=template&id=6baafcc4&scoped=true&"
import script from "./upload-contract-page.vue?vue&type=script&lang=js&"
export * from "./upload-contract-page.vue?vue&type=script&lang=js&"
import style0 from "./upload-contract-page.vue?vue&type=style&index=0&id=6baafcc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baafcc4",
  null
  
)

export default component.exports